import React from "react";

import { ArrowRight as ArrowRightIcon } from "react-feather";
import {
  IconButton,
  ListItem,
  ListItemText,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import { formatDistanceStrict } from "date-fns";

import { NewsItemProps } from "./types";
import { getPostSummary } from "./helpers";

const useStyles = makeStyles(theme => ({
  summary: {
    fontWeight: theme.typography.fontWeightMedium,
    paddingRight: theme.spacing(1),
    "&::after": {
      content: "'...'",
    },
  },
}));

const NewsItem: React.FC<NewsItemProps> = ({
  newsItem: { id, date, content, type },
  handleClick,
}) => {
  const classes = useStyles();

  const onClick = () => handleClick(id, type);

  return (
    <ListItem data-test="news-list-item" alignItems="flex-start">
      <ListItemText
        primaryTypographyProps={{ variant: "body2" }}
        secondary={
          <span data-test="news-list-item-date">
            {formatDistanceStrict(new Date(Date.now()), new Date(date))}
          </span>
        }
      >
        <article className={classes.summary} data-test="news-list-item-content">
          {getPostSummary(content)}
        </article>
      </ListItemText>
      <Tooltip title="View news story">
        <IconButton onClick={onClick}>
          <ArrowRightIcon />
        </IconButton>
      </Tooltip>
    </ListItem>
  );
};

export default NewsItem;
